var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.20138 8.49617C4.85649 8.84106 4.85649 9.40031 5.20138 9.7452L9.52223 14.0618C10.2122 14.7511 11.3302 14.7508 12.0198 14.0612L16.339 9.74202C16.6839 9.39713 16.6839 8.83788 16.339 8.49299C15.9941 8.148 15.4348 8.148 15.0899 8.49299L11.3931 12.1898C11.0482 12.5347 10.489 12.5347 10.1441 12.1898L6.45042 8.49617C6.10553 8.15127 5.54628 8.15127 5.20138 8.49617Z",
    fill: "#3B3B3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/arrow-down-black.14c2da3940559e54d01578700d62daff.svg";
export { ForwardRef as ReactComponent };